// extracted by mini-css-extract-plugin
module.exports = {"iframe":"InstallationManual_iframe__2xq9N","lastUpdated":"InstallationManual_lastUpdated__28TE_"};